// extracted by mini-css-extract-plugin
export default {"contentWrapper":"SearchPage_contentWrapper__kFK7o","title":"SearchPage_title__1ajhv"};